import { analyticsClient } from '../common/analyticsClient';
import type { AnalyticsEventRequest } from './utils/types';

const IDENTIFIED_CRAWLER_PATTERN =
  /(?:googlebot|bingbot|duckduckbot|yandexbot|applebot|petalbot|adsbot-google|googleother|inspectiontool|oai-searchbot|gptbot|amazonbot|semrushbot|ahrefsbot|mj12bot|dotbot|crawler|spider|slurp|facebookexternalhit|lighthouse|pagespeed|(?:^|[\s;/()+_-])bot\b)/i;

class AnalyticsAPIClient {
  public async trackEvent(payload: AnalyticsEventRequest): Promise<void> {
    if (isKnownWebCrawler(payload)) {
      return;
    }

    if (!payload.uniqueId) {
      payload.uniqueId = createAnalyticsEventId();
    }
    await analyticsClient.post('/a/event', payload);
  }
}

export const analyticsAPIClient = new AnalyticsAPIClient();

function isKnownWebCrawler(payload: AnalyticsEventRequest): boolean {
  if (payload.analytics.platform !== 'Web' || typeof navigator === 'undefined') {
    return false;
  }

  const userAgent = navigator.userAgent;
  return IDENTIFIED_CRAWLER_PATTERN.test(userAgent);
}

export function createAnalyticsEventId(): string {
  const randomUUID = globalThis.crypto?.randomUUID;
  if (typeof randomUUID === 'function') {
    return randomUUID.call(globalThis.crypto);
  }
  return `evt_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 12)}`;
}
